import React, { useContext, useState } from 'react';
import { SettingsContext } from "../Context";
import Modal from 'react-bootstrap/lib/Modal';

function ListItemImage(props) {

    const settings = useContext(SettingsContext);
    const [imageOpen, setImageOpen] = useState(false);

    function handleImageClick(e) {
        setImageOpen(true);
    }

    function handleClose() {
        setImageOpen(false);
    }

    return (
        <div className="vehicleProductListComponent-imgWrapper">
            {props.imageThumbUrl && <img className="vehicleProductListComponent-imgWrapperImg img-fluid" src={props.imageThumbUrl} alt={props.alt} />}
            {settings.zoomIconUrl && <div className="vehicleProductListComponent-zoomWrapper" onClick={handleImageClick}>
                <img src={settings.zoomIconUrl} className="vehicleProductListComponent-zoomImg" />
            </div>}

            <Modal show={imageOpen} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{props.articleNumber}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <img className="img-responsive center-block" src={props.imageUrl} alt={props.alt} />
                    
                </Modal.Body>
            </Modal>
        </div>);
}
export default ListItemImage;